



































































































   import { Vue, Component, Watch } from 'vue-property-decorator';
   import { store, StoreState, HellospokeContact,AppSettings } from '../../store';
   import { mapState } from 'vuex';
   import VeeValidate from 'vee-validate';     
   import VueElementLoading from 'vue-element-loading';
   import {RotateSquare2} from 'vue-loading-spinner';
   import axios from 'axios'; 

   declare interface ContactInfoData {
       feedbackClass: "feedback-success" | "feedback-failure";
      // feedbackMessage: "" | "Contact information saved." | "Contact information could not be saved. Try again later.";
   }

@Component({
       components: {
           RotateSquare2,VueElementLoading,
       },
       computed: {
           ...mapState({
               'selectedContact': (state: StoreState) => state.dashboard.selectedContact,
               'incomingCaller': (state: StoreState) => state.dashboard.incomingCaller,
               'contacts': (state: StoreState) => state.dashboard.contacts,
               'EditContact':(state: StoreState) => state.dashboard.editcontact_status, //result_contacts
               'FormEditContact':(state: StoreState) => state.dashboard.selected_contact, 
               'feedbackMessage':(state: StoreState) => state.dashboard.feedbackMessage, 
               'isLoading':(state: StoreState) => state.dashboard.contact_info_loader, 
           }),
       },  
       methods:{
           fileChange(file) {
           // To check if file is an image
           if (!file.target.files[0].name.match(/.(jpg|jpeg|png|gif)$/i)) {
               alert('not an image');
               file.target.value = null
              // this.$emit('imageChanged', null)
               return;
           }
            this.$data.Editcropped_status=true;
           var reader = new FileReader();
           reader.readAsDataURL(file.target.files[0]);
           reader.onload = () => {
               this.$data.dialog = true;
               // bind the result of the file 
               // to croppie
                 var self= (this.$refs as any);
                  self.croppieRef.bind({
                           url: reader.result,
                   });
              
               file.target.value = null
           };
           reader.onerror = (error) => {
               console.log('Error: ', error);
           };
       },
      
         
      }

   })
   export default class EditContact extends Vue {  

        data() {
           return {  
               Editcropped_status:false,
               Error_Msg:false,
               feedbackClass: "feedback-success",
               URLIMGPLUS_G:"/img/icons/person.png",
                profile:"/img/icons/camera.png",
               main_numstatus:false,
               mob_numstatus:false,
               Email_status:'',
               Number_status:false,
               submitted: false,
               mainum_mobnum:false,
               imagUploading:false,
             
               private_public:[
                           { Name: "Private", Id: 0 },
                           { Name: "Public", Id: 1 }
                           ],
              
           } as ContactInfoData;
       }

   public clearError(){
       this.$data.mob_numstatus= this.$data.main_numstatus=  false;
       this.$data.Error_Msg=false;
       this.$data.submitted=false;
       //this.errors.clear();   
   }    
   
  onblur(){
        this.$data.mainum_mobnum=false;
   }
  

    isNumber(event, message) {
           if (!/\d/.test(event.key) &&  
               (event.key !== "." || /\./.test(message))     
           )  
               return event.preventDefault();  
           }

       crop() { 
           // Here we are getting the result via callback function
           // and set the result to this.cropped which is being 
           // used to display the result above.
              this.$data.sendingImage = true;
              (this as any).imagUploading=true;
             var self= (this.$refs as any);
             let options = {
                 format: 'jpeg', 
                 circle: true
             };
              self.croppieRef.result(options, (output) => { 
               this.$data.cropped = output;
              (this as any).selectedContact.imageUrl =this.$data.cropped;
                   (this as any).imagUploading=false;
                   (this as any).imageupload=true;
               this.$data.Editcropped_status=false;
                   this.$store.dispatch('submitContactChanges', (this as any).selectedContact).then(r => {
                   this.$store.commit('FEEDBACKMESSAGE_CONTACT', "Contact information saved."); 
               }).catch(() => {
                    this.$store.commit('FEEDBACKMESSAGE_CONTACT', "Contact information could not be saved. Try again later."); 
                });

           });  
       }
     
   _SUBMIT(e){
           this.$data.submitted = true;
           this.$data.mainum_mobnum=true;
           this.$validator.validate().then(valid => {
           this.$data.Error_Msg=valid?false:true;
           var yhg=(this as any).FormEditContact;
           this.$data.mainum_mobnum=(this as any).FormEditContact.main!=""||(this as any).FormEditContact.mobile!=""?false:true;
           if (valid && !this.$data.mainum_mobnum) {
               const payload = JSON.parse(JSON.stringify((this as any).selectedContact));
                   payload.first_name    = (this as any).FormEditContact.firstName;
                   payload.last_name     = (this as any).FormEditContact.lastName; 
                   payload.compny_name   = (this as any).FormEditContact.comyName; 
                   payload.address.line1 = (this as any).FormEditContact.addline1;
                   payload.address.line2 = (this as any).FormEditContact.addline2;
                   payload.address.city  = (this as any).FormEditContact.city;
                   payload.address.state = (this as any).FormEditContact.state;
                   payload.address.zip   = (this as any).FormEditContact.zip;
                   payload.custermerid   = (this as any).FormEditContact.customerid; 
                   payload.extension     = (this as any).FormEditContact.extension; 
                   payload.private       = ((this as any).FormEditContact.Id==0 ) ?true:false
               {
               {
                   if((this as any).FormEditContact.mobile!=""&&(this as any).FormEditContact.main=="")
                   {
                   if(!this.validatePhoneNumber((this as any).FormEditContact.mobile)) {
                       this.$data.mob_numstatus=true;
                       alert("Please enter a valid phone number");
                      return;
                   }
                   else{ 
                       payload.numbers.mobile.number=this.validat_num((this as any).FormEditContact.mobile);
                       this.$data.mob_numstatus=false;
                       payload.numbers.main[0]=(this as any).FormEditContact.main;   
                       }
                   }
               }
              
              {
                   if((this as any).FormEditContact.mobile==""&&(this as any).FormEditContact.main!="")
                  {
                      
                   if(!this.validatePhoneNumber((this as any).FormEditContact.main)) {
                       this.$data.main_numstatus=true;
                       alert("Please enter a valid main number");
                       return;
                   }
                   else{
                       payload.numbers.main[0]=this.validat_num((this as any).FormEditContact.main);
                       this.$data.main_numstatus=false;
                       payload.numbers.mobile.number=(this as any).FormEditContact.mobile;  
                       }
                  }
               }
              {
               if((this as any).FormEditContact.mobile!=""&&(this as any).FormEditContact.main!="")
               {
                   {
                       if(!this.validatePhoneNumber((this as any).FormEditContact.main)) {
                           this.$data.main_numstatus=true;
                           alert("Please enter a valid main number");
                               return;
                       }
                       else{payload.numbers.main[0]=this.validat_num((this as any).FormEditContact.main);this.$data.main_numstatus=false; }
                   }
                   {
                       if(!this.validatePhoneNumber((this as any).FormEditContact.mobile)) {
                           this.$data.mob_numstatus=true;
                          alert("Please enter a valid Phone number");
                           return;
                           }
                       else{ payload.numbers.mobile.number=this.validat_num((this as any).FormEditContact.mobile); this.$data.mob_numstatus=false;}
                   }
               }  
              }
               {
                   if((this as any).FormEditContact.email != '' && !this.validateEmail((this as any).FormEditContact.email)) {
                   alert("Please enter a valid email address.");
                   return;
               }
                   payload.email[0] = (this as any).FormEditContact.email;
               }
               } 
              
               var result_messg;
                this.$store.commit('SHOW_CONTACT_INFOLOADER', true);
              if(this.$data.Email_status==''||this.$data.Email_status==true && this.$data.Number_status==true )
                this.$store.dispatch('submitContactChanges', payload).then(r => {    
                   this.$store.commit('FEEDBACKMESSAGE_CONTACT', "Contact information saved."); 
               }).catch(() => {
                    this.$store.commit('FEEDBACKMESSAGE_CONTACT', "Contact information could not be saved. Try again later."); 
                });
                var self=this;
                    setTimeout(function(){
                    self.feedback_Failure_success(result_messg) ;
                   }, 3000);
                   }
               });
   }

   feedback_Failure_success(mes){
       this.$store.commit("SHOW_CONTACT_DETAIL", true);
      this.$emit('contact_detail')
       this.$store.commit('SHOW_CONTACT_INFOLOADER', false);
       this.$store.commit("EDIT_CONTACT_UPDATE",false);
       this.$data.submitted = false;
   }


   fileUploaded(files) {
      // alert(JSON.stringify(files))
           var FileSize=files[0].size;
           var Max_fileSize=Math.round(FileSize / 1000000); //size in mb;
           if(Max_fileSize>4)
               {
                  alert('Attachment may not exceed 5MB.');
               }
          else{
               this.$data.sendingImage = true;
               (this as any).imagUploading=true;
               let formData = new FormData();
               JSON.parse(JSON.stringify((this as any).selectedContact))
               formData.append('file', files[0]);
               axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.$store.state.account.jwt;
               axios.post( `${AppSettings.API_HOST}uploadContactImage`,
                   formData,
                   {
                       headers: {
                           'Content-Type': 'multipart/form-data'
                       },
                   }
               ).then(r => {
                   (this as any).selectedContact.imageUrl = r.data.imageurl;
                   (this as any).imagUploading=false;
                   this.$store.dispatch('submitContactChanges', (this as any).selectedContact).then(r => {
                   this.$store.commit('FEEDBACKMESSAGE_CONTACT', "Contact information saved."); 
               }).catch(() => {
                   (this as any).imagUploading=false;
                   this.$data.sendingImage = false;
                    this.$store.commit('FEEDBACKMESSAGE_CONTACT', "Contact information could not be saved. Try again later."); 
                });
                   //scrolldown = setTimeout(this.scroTobottom, 1000);
               })
               .catch(r => {
                   this.$data.sendingImage = false;
                   (this.$refs.fileInput as any).value = null;
                   console.log('failed', r);
               });
          }
       }
   //Looks similar to the refs version, but uses data instead.
   //v-model didn't seem to work with divs, but I would think that
   //this would also be reactive, will change if it isn't.
   feedbackSuccess() {
       this.$data.feedbackClass = "feedback-success";
       this.$data.feedbackMessage = "Contact information saved.";
   }

   feedbackFailure() {
       this.$data.feedbackClass = "feedback-failure";
       this.$data.feedbackMessage = "Contact information could not be saved. Try again later.";
   }

   validateEmail(email: any) {
       //Breakdown of this Regex can be found here:
       //https://www.w3resource.com/javascript/form/email-validation.php
       //Seems to cover most all cases.
        const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;;///^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
       if(!re.test(email)) {
               this.$data.Email_status=false;
               return false;
           }
       this.$data.Email_status=true;
       return true;
   }
   validatePhoneNumber(phoneNumber: any) {
       if(!phoneNumber) {
           return false;
      }
      if(typeof phoneNumber === "number") {
               phoneNumber = phoneNumber.toString();
       }
       //strip all potential nondigits
       phoneNumber = phoneNumber.replace(/\(/g, '').replace(/\)/g, '').replace(/ /g, '').replace(/-/g, '').replace(/\+/, '');
        if(!(/[1-9]{1}[0-9]{9}/.test(phoneNumber)))   
         {
         this.$data.Number_status=false;
           return false;
          }
       //Allow US country code if supplied
       const re = /^1?\d{10}$/;
       if(!re.test(phoneNumber)) {
           this.$data.Number_status=false;
           return false;
       }
       this.$data.Number_status=true;
           return true;
   }
   validat_num(Number: any){
      let mob_number = Number//this.$data.NewContact_User.mobile;
          mob_number = mob_number.replace(/\(/g, '').replace(/\)/g, '').replace(/ /g, '').replace(/-/g, '').replace(/\+/, '');
       if(mob_number.length === 10) {
          mob_number = `+1${mob_number}`;
        }
       else {
           mob_number = `+${mob_number}`;
       }
       return mob_number;
           //this.$data.NewContact_User.mobile=mob_number;
   }

       

   formatPhoneNumber(phoneNumber: any) {
       if(typeof phoneNumber === "number") {
               phoneNumber = phoneNumber.toString();
       }
       //This regex is based off the format of phone numbers
       //as they are returned in the contact list by the Kazoo API.
       //Link: https://github.com/2600hz/kazoo/blob/master/applications/crossbar/doc/contact_list.md
       //If the Hellospoke database uses a different format will adjust
       //the pattern accordingly
       const re = /(?:\+1)?(\d{3})(\d{3})(\d{4})/;
       const matches = phoneNumber.match(re);
       if(matches === null) {
           console.log("The phone number " + phoneNumber + " could not be parsed");
           return "Invalid number";
       }
        return `(${matches[1]}) ${matches[2]}-${matches[3]}`;
   }

  
       
   }
